import { render, staticRenderFns } from "./forget_password.vue?vue&type=template&id=16af085e&scoped=true"
import script from "./forget_password.vue?vue&type=script&lang=js"
export * from "./forget_password.vue?vue&type=script&lang=js"
import style0 from "./forget_password.vue?vue&type=style&index=0&id=16af085e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16af085e",
  null
  
)

export default component.exports